// extracted by mini-css-extract-plugin
module.exports = {"question-modal":"SuccessModal_question-modal__8g2Wi"};